import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { LinkProps } from "@/components/wpl/link/src";
import { useLocalizedHref } from "@/libraries/web-framework";

const wrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    padding: "20px"
});

const headerStyle = css({
    textTransform: "uppercase",
    color: "#101214",
    fontSize: "0.75rem",
    fontFamily: "var(--bxp-charlie-text-font-family)",
    fontWeight: 700,
    lineHeight: "1rem"
});

const linkColumnStyle = css({
    display: "grid",
    gridAutoRows: "40px",
    width: "184px"
});

const linkStyle = css({
    "margin": 0,
    "color": "#101214",
    "fontSize": ".875rem",
    "alignSelf": "end",
    ":hover": {
        color: "#1868DB"
    }
});
interface DropdownContentSectionProps {
    header: string;
    links: LinkProps[];
}

const CategoriesDropdownContentSection = ({
    header,
    links
}: DropdownContentSectionProps) => {
    return (
        <div css={wrapperStyle}>
            <span css={headerStyle}>{header}</span>
            <div css={linkColumnStyle}>
                {links.map((link) => (
                    <a
                        key={link.text}
                        href={link.href}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-event-container="Sub-Nav-link-in-dropdown"
                        css={linkStyle}
                        onClick={link.onClick}
                    >
                        {link.text}
                    </a>
                ))}
            </div>
        </div>
    );
};

export const CategoriesDropdown = () => {
    const intl = useIntl();

    return (
        <CategoriesDropdownContentSection
            key={"categories"}
            header={intl.formatMessage({
                id: "jira-templates.subnav.categories.type.header",
                defaultMessage: "categories"
            })}
            links={[
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.software-development",
                        defaultMessage: "Software Development"
                    }),
                    href: useLocalizedHref(
                        "/software/jira/templates/software-development"
                    )
                },
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.marketing",
                        defaultMessage: "Marketing"
                    }),
                    href: useLocalizedHref("/software/jira/templates/marketing")
                },
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.design",
                        defaultMessage: "Design"
                    }),
                    href: useLocalizedHref("/software/jira/templates/design")
                },
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.sales",
                        defaultMessage: "Sales"
                    }),
                    href: useLocalizedHref("/software/jira/templates/sales")
                },
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.operations",
                        defaultMessage: "Operations"
                    }),
                    href: useLocalizedHref(
                        "/software/jira/templates/operations"
                    )
                },
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.service-management",
                        defaultMessage: "Service Management"
                    }),
                    href: useLocalizedHref(
                        "/software/jira/templates/service-management"
                    )
                },
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.hr",
                        defaultMessage: "HR"
                    }),
                    href: useLocalizedHref("/software/jira/templates/hr")
                },
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.legal",
                        defaultMessage: "Legal"
                    }),
                    href: useLocalizedHref("/software/jira/templates/legal")
                },
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.it-operations",
                        defaultMessage: "IT Operations"
                    }),
                    href: useLocalizedHref(
                        "/software/jira/templates/it-operations"
                    )
                },
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.finance",
                        defaultMessage: "Finance"
                    }),
                    href: useLocalizedHref("/software/jira/templates/finance")
                },
                {
                    text: intl.formatMessage({
                        id: "jira-templates.subnav.categories.type.project-management",
                        defaultMessage: "Project Management"
                    }),
                    href: useLocalizedHref("/project-management/templates")
                }
            ]}
        />
    );
};
